import { ClearOutlined } from '@ant-design/icons'
import { Button, DatePicker, Form, InputNumber, Select, Table } from 'antd'
import { FC } from 'react'
import { stampOrderOrderStatuses } from '../../../../../constants/entity-enums/stamp-order-order-statuses'
import useFiltersForm from '../../../../../hooks/forms/use-filters-form'
import Initiators from './components/initiators'
import { outputDateFormat } from '../../../../../constants/constants'

interface FiltersFormProps {}

const FiltersForm: FC<FiltersFormProps> = () => {
    const { form, onSearch, onClear } = useFiltersForm()

    return (
        <Form
            form={form}
            component={false}
            variant={'filled'}
            onFieldsChange={() => {
                onSearch()
            }}
        >
            <Table.Summary.Cell index={0}>
                <Form.Item name={'number'} noStyle>
                    <InputNumber style={{ width: '100%' }} controls={false} placeholder={'Номер'} />
                </Form.Item>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={1}>
                <Form.Item name={'stampNumber'} noStyle>
                    <InputNumber style={{ width: '100%' }} controls={false} placeholder={'Штамп'} />
                </Form.Item>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={2}>
                <Form.Item name={'createdAt'} noStyle>
                    <DatePicker placeholder={'Дата'} format={outputDateFormat} />
                </Form.Item>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={3}>
                <Form.Item name={'estimatedDate'} noStyle>
                    <DatePicker placeholder={'Дата'} format={outputDateFormat} />
                </Form.Item>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={4}>
                <Form.Item name={'orderStatuses'} noStyle>
                    <Select
                        style={{ width: '100%' }}
                        options={stampOrderOrderStatuses.map(item => ({ value: item }))}
                        placeholder={'Статус'}
                        mode={'multiple'}
                    />
                </Form.Item>
            </Table.Summary.Cell>
            <Table.Summary.Cell index={5}>
                <Initiators />
            </Table.Summary.Cell>
            <Table.Summary.Cell index={8} />
            <Table.Summary.Cell index={9} />
            {/* TODO: кнопка уходит за экран, решить, если решим, то нужно попробовать решить в отгрузках, там тоже на 2 колонки почему то */}
            <Table.Summary.Cell index={10}>
                <Button
                    size={'small'}
                    icon={<ClearOutlined />}
                    title={'Сбросить фильтры'}
                    onClick={onClear}
                >
                    Сброс
                </Button>
            </Table.Summary.Cell>
        </Form>
    )
}

export default FiltersForm
